import { Typography, InputAdornment } from '@mui/material';
import PropTypes from 'prop-types';

export const FirstTextSelect = ({ text }) => (
  <InputAdornment
    position="start"
    sx={{
      marginRight: 0
    }}>
    <Typography component="span" variant="body1" color="text.primary">
      {text}
    </Typography>
  </InputAdornment>
);

FirstTextSelect.propTypes = {
  text: PropTypes.string
};
